import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageTitleService, PageTitleConfig } from '../../_services/page-title.service';
import { Subject, takeUntil } from 'rxjs';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-page-title',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss']
})
export class PageTitleComponent implements OnInit, OnDestroy {
  titleConfig: PageTitleConfig = { title: '', subtitle: '', showTitle: false };
  url: string = '';
  private destroy$ = new Subject<void>();
  constructor(private pageTitleService: PageTitleService) {}
  ngOnInit() { this.pageTitleService.titleConfig$.pipe(takeUntil(this.destroy$)).subscribe((c: PageTitleConfig) => this.titleConfig = c); }
  ngOnDestroy() { this.destroy$.next(); this.destroy$.complete(); }
}
